/* global Promise */
import angular from 'angular';
import * as R from 'ramda';

export default function ResetImpactAnalysisDialogController(
  $rootScope,
  $q,
  alerts,
  ssDialogService,
  loaderService,
  bcpDataService
) {
  const vm = this;

  vm.hasData = false;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleBulkRevert = _handleBulkRevert;

  vm.handleSelectProcessChange = _handleSelectProcessChange;
  vm.handleSelectAll = _handleSelectAll;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    vm.resettableProcesses = [];
    angular.forEach(vm.processes, (process) => {
      if (process && process.impactAnalysis && (process.impactAnalysis.submitted === true)) {
        vm.resettableProcesses.push(process);
      }
    });

    if (vm.processes.length > 0) {
      vm.hasData = true;
    }
  }

  function _handleCloseDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.bcp.resetImpactAnalysisDialog);
  }

  function _handleSelectProcessChange() {
    const selectedIds = [];

    R.forEach((item) => {
      if (item.isSelected === true) {
        selectedIds.push(item.processId);
      }
    }, vm.processes);

    vm.revertIsSelected = selectedIds.length > 0;
    vm.selectAll = selectedIds.length === vm.processes.length;
  }
  
  function _handleSelectAll() {
    R.forEach((item) => {
      item.isSelected = vm.selectAll;
    }, vm.processes);
      
    vm.revertIsSelected = vm.selectAll;
  } 

  function _handleBulkRevert() {
    loaderService.showViewLoader = true;
    const resetProcess = [];
    // Find selections
    angular.forEach(vm.processes, (process) => {
      if (process && process.isSelected) {
        resetProcess.push(process.assessmentProcessId);
      }
    });
    // Stop if no selections
    if (resetProcess.length <= 0) {
      vm.isSelected = false;
      loaderService.showViewLoader = false;
      return Promise.resolve();
    }
    // Reset selected
    return bcpDataService.resetAssessmentProcessStatus(vm.assessmentId, resetProcess).then(() => {
      alerts.success('The Business Impact Analysis Processes have been reset successfully.');
      ssDialogService.hide(ssDialogService.dialogs.bcp.resetImpactAnalysisDialog);
      loaderService.showViewLoader = false;
      $rootScope.$broadcast('refreshBCPAssessments');
    },
    () => {
      alerts.error('The Business Impact Analysis Processes have failed to reset.');
      loaderService.showViewLoader = false;
    });
  }
}

ResetImpactAnalysisDialogController.$inject = [
  '$rootScope',
  '$q',
  'alerts',
  'ssDialogService',
  'loaderService',
  'bcpDataService'
];
